import { createAction } from '@ngrx/store';

export const showAppMenu = createAction('[App Menu] Show');
export const hideAppMenu = createAction('[App Menu] Hide');
